export default __webpack_public_path__ + "static/media/work-6.305499b2.jpg";